import { LinkItem } from 'Types/intellioInsights';

export const apqcDataMetrics: LinkItem[] = [
  {
    id: 'a1b2c3d4-e5f6-47a8-b9c0-1d2e3f4a5b6c',
    label: 'APQC Metrics',
    href: 'https://app.powerbi.com/reportEmbed?reportId=ed5291b5-bc50-42b8-a9d5-2f3a8045b329&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
    isNew: true,
  },
];

export const industryDataMetrics: LinkItem[] = [
  {
    id: '7a8b9c0d-1e2f-43a4-b5c6-d7e8f9a0b1c2',
    label: 'Industry KPI Search',
    href: 'https://app.powerbi.com/reportEmbed?reportId=0156f697-cf98-4a84-8870-27938638c68d&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
];

export const industryData: LinkItem[] = [
  {
    id: '3d4e5f6a-7b8c-49d0-a1e2-f3a4b5c6d7e8',
    label: 'C&IP Metrics',
    href: 'https://app.powerbi.com/reportEmbed?reportId=49e2ea74-7b32-4fd8-8394-49c33efb6be0',
  },
  {
    id: '9f0a1b2c-3d4e-45f6-a7b8-c9d0e1f2a3b4',
    label: 'C&IP Account Selector',
    href: 'https://app.powerbi.com/links/QxlyUj7yBO',
  },
  {
    id: '5c6d7e8f-9a0b-41c2-d3e4-f5a6b7c8d9e0',
    label: 'High Tech & Software Metrics',
    href: 'https://app.powerbi.com/reportEmbed?reportId=e892f78a-51d9-4189-81f5-db4b0efacb58',
  },
];

export const capabilitiesData: LinkItem[] = [
  {
    id: '1a2b3c4d-5e6f-47a8-b9c0-d1e2f3a4b5c6',
    label: 'IT Spend & Staffing',
    href: 'https://app.powerbi.com/reportEmbed?reportId=144ce511-9eee-4995-b629-06141fb11084&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
  {
    id: '7d8e9f0a-1b2c-43d4-e5f6-a7b8c9d0e1f2',
    label: 'Infrastructure & Cybersecurity Advisory',
    href: 'https://app.powerbi.com/reportEmbed?reportId=bf112d2f-5c8f-4b1f-b1d0-7c747a976e8c&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
  {
    id: 'a3b4c5d6-e7f8-49a0-b1c2-d3e4f5a6b7c8',
    label: 'Software Financial & Operational Metrics',
    href: 'https://app.powerbi.com/reportEmbed?reportId=2d3e883c-8b4e-42b9-b735-f6cc51bd555a&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
  {
    id: '9d0e1f2a-3b4c-45d6-e7f8-a9b0c1d2e3f4',
    label: 'Sales & Marketing Metrics',
    href: 'https://app.powerbi.com/links/keKzF1iCC1?ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f&pbi_source=linkShare',
    isNew: true,
  },
];

export const capabilitiesDataCape: LinkItem[] = [
  {
    id: '5f6a7b8c-9d0e-41f2-a3b4-c5d6e7f8a9b0',
    label: 'Compilance & Cybersecurity Advisory',
    href: 'https://app.powerbi.com/reportEmbed?reportId=5e2db0ba-6e25-4f50-beb2-3f44e44c6f21&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
  {
    id: 'c1d2e3f4-a5b6-47c8-d9e0-f1a2b3c4d5e6',
    label: 'Compilance & Cybersecurity Advisory - Client',
    href: 'https://app.powerbi.com/reportEmbed?reportId=ea512654-2e9a-4c63-84d6-98ab10fe202a&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtZy1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9',
  },
];

export const capabilitiesDataBpo: LinkItem[] = [
  {
    id: 'f7a8b9c0-d1e2-43f4-a5b6-c7d8e9f0a1b2',
    label: 'Strategic Workforce Optimization',
    href: 'https://app.powerbi.com/links/aixvEUSS7z?ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f&pbi_source=linkShare&bookmarkGuid=e3686005-a631-41ff-b1f5-e5ec63d940ff',
  },
];

export const clientStrategyData: LinkItem[] = [
  {
    id: 'b3c4d5e6-f7a8-49b0-c1d2-e3f4a5b6c7d8',
    label: 'Analytics Use Case Repository',
    href: 'https://app.powerbi.com/reportEmbed?reportId=ff0bac45-9201-44cb-aff3-dfea1dfb1df4&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
  {
    id: 'e9f0a1b2-c3d4-45e6-f7a8-b9c0d1e2f3a4',
    label: 'Gen AI Use Case Repository',
    href: 'https://app.powerbi.com/reportEmbed?reportId=eb2332d8-95c0-406a-ace6-cdfee39d3a9c&autoAuth=true&ctid=c2a23be5-d2cf-4e70-84ce-18adf87d571f',
  },
];
